// extracted by mini-css-extract-plugin
export default {"img-box":"studentCards_img-box__Mgo0Q","row":"studentCards_row__uWlWy"};